export const START_WORDLE_GAME_COMPLETED = "wordle/startGameCompleted";
export const GUESS_WORDLE_COMPLETED = "wordle/guessWordleCompleted";
export const GET_WORDLE_STATUS_COMPLETED = "wordle/getStatusCompleted";
